(function sidebarMenuScript($, Drupal) {
  'use strict';

  Drupal.behaviors.sidebarMenu = {
    attach(context, settings) {
      
      var $nav = $('#sidebar-nav', context);
      var $nav_title = $nav.find('.sidebar-nav-label', context);
      var $menu = $nav.children('.sidebar-menu', context);
      var $main_top_item = $('header .main-menu__item--active-trail', context).html();
      var $utility_top_item = $('header .utility-menu-list__item--active-trail', context).html();
      
      // Replace label on menu with active trail top level item text
      if ($utility_top_item !== undefined) {
        $nav_title.once().append($utility_top_item  + '<span class="toggle" tabIndex="0">toggle</span>');
      }
      if ($main_top_item !== undefined) {
        $nav_title.once().append($main_top_item  + '<span class="toggle" tabIndex="0">toggle</span>');
      }
      
      // Expose sub menu on hover.
      $nav.each(function() {
        var $nav_toggle = $nav.find('.toggle', context);
        var toggleMenu = function() {
          $nav_title.toggleClass('sidebar-nav-label-open');
          $menu.toggleClass('sidebar-menu-open');
        };
        // Toggle menu for keyboard.
        $nav_toggle.on('click keypress', function(e){
          if(e.type == 'click'){
            toggleMenu();
          }
          if(e.keyCode == 13){
            toggleMenu();
          }
        });
      });
      
      $menu.each(function() {
        $(this).smartmenus({
          collapsibleBehavior: 'link',
          markCurrentItem: true,
          noMouseOver: true,
          subIndicatorsText: '',
          hideOnClick: false
        });
      });
      
      $menu.smartmenus('itemActivate', $('a.current').eq(-1));
      
    },
  };
    
}(jQuery, Drupal));
